import {
  Box,
  type Colors,
  Icon,
  InjectColorProvider,
  Text,
} from '@factorialco/deprecated-design-system'
import type { Currency } from 'dinero.js'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface Props {
  amount?: number
  currency?: Currency
}

const COLOR_POSITIVE = 'viridian1200'
const COLOR_NEUTRAL = 'grey700'
const COLOR_NEGATIVE = 'radicalRed1200'

const CompareText = ({ amount, currency }: Props) => {
  const isUnknown = typeof amount !== 'number'
  const isPositive = (amount ?? 0) >= 0
  const isZero = (amount ?? 0) === 0
  const absoluteAmount = Math.abs(amount ?? 0)
  const {
    access: { locale },
  } = useCurrentSession()

  const money = MoneyWithCurrency({
    optionalDecimals: true,
    amount: Number(absoluteAmount),
    currency: currency || 'EUR',
    locale,
  })

  const getText = () => {
    return currency ? <span>{money}</span> : <span>{absoluteAmount}</span>
  }

  const getColor: () => Colors | undefined = () => {
    // NOTE: Yes, we must return nothing here, otherwise the icon wont be readable due to the color
    if (isUnknown) return

    if (isZero) return COLOR_NEUTRAL

    if (isPositive) return COLOR_POSITIVE

    return COLOR_NEGATIVE
  }

  const color = getColor()
  const text = getText()

  return (
    <InjectColorProvider color={color}>
      <Box flexDirection="row" alignItems="center">
        {isUnknown && (
          <InformationTooltip
            information={i18n.t(
              'payroll_bundle.results_payments.results.previous_value_not_informed'
            )}
            icon="question"
          />
        )}
        {!isUnknown && !isZero && (
          <Box flexDirection="row" alignItems="center" gap="s2">
            <Icon.Small
              icon={isPositive ? 'arrow-top-right' : 'arrow-bottom-right'}
              color={color}
            />
            <Text color={color} size="100" weight="medium">
              {text}
            </Text>
          </Box>
        )}
      </Box>
    </InjectColorProvider>
  )
}

export default CompareText
